// removed by extract-text-webpack-plugin
module.exports = {"container_buttons":"styles__container_buttons___32QeZ","cancelButton":"styles__cancelButton___2POkB","sendButton":"styles__sendButton___3OGxr","infoContact":"styles__infoContact___220Gp","load_container":"styles__load_container___pat-x","modal_container":"styles__modal_container___HkxZz","error":"styles__error___gHtJB","button_container":"styles__button_container___3QO-t","titleCard":"styles__titleCard___3pfsw","fileInfo":"styles__fileInfo___3pVIR"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/Pages/ExpertAnalysis/styles.css
// module id = 3218
// module chunks = 0